// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1jSmq","footer":"styles_footer__1DYLn","passCodeTooltip":"styles_passCodeTooltip__240FG"};